export default __webpack_public_path__ + "assets/76fff4a03854d52570f2c28b54f59943.woff2";